<script lang="ts">
	import '$lib/assets/css/hero.css';

	let width = $state(0);
</script>

<div class="~h-[21rem]/[28rem] w-full overflow-hidden rounded-base" bind:offsetWidth={width}>
	{#if width > 1400}
		<picture>
			<source srcset="/img/main-1500x471.avif" type="image/avif" width="1500" height="471" />
			<source srcset="/img/main-1500x471.webp" type="image/webp" width="1500" height="471" />
			<img
				src="/img/main-1500x471.jpg"
				alt="Private Taxi and Shuttle Shared Service"
				width="1500"
				height="471"
				class="w-full h-full object-cover"
			/>
		</picture>
	{:else if width > 800 && width < 1400}
		<picture>
			<source srcset="/img/main-1200x377.avif" type="image/avif" width="1200" height="377" />
			<source srcset="/img/main-1200x377.webp" type="image/webp" width="1200" height="377" />
			<img
				src="/img/main-1200x377.jpg"
				alt="Private Taxi and Shuttle Shared Service"
				width="1200"
				height="377"
				class="w-full h-full object-cover"
			/>
		</picture>
	{:else if width > 500 && width < 800}
		<picture>
			<source srcset="/img/main-800x251.avif" type="image/avif" width="800" height="251" />
			<source srcset="/img/main-800x251.webp" type="image/webp" width="800" height="251" />
			<img
				src="/img/main-800x251.jpg"
				alt="Private Taxi and Shuttle Shared Service"
				width="800"
				height="251"
				class="w-full h-full object-cover"
			/>
		</picture>
	{:else if width > 0 && width < 500}
		<picture>
			<source srcset="/img/main-500x677.avif" type="image/avif" width="500" height="677" />
			<source srcset="/img/main-500x677.webp" type="image/webp" width="500" height="677" />
			<img
				src="/img/main-500x677.jpg"
				alt="Private Taxi and Shuttle Shared Service"
				width="500"
				height="677"
				class="w-full h-full object-cover"
			/>
		</picture>
	{/if}
</div>
